import React from 'react';
import { string, func, object } from 'prop-types';
import { Button, Input } from '@fiverr-private/fit';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { getBriefUrl } from '../../../lib';
import CloudinaryResponsiveImage from '../../CloudinaryResponsiveImage';
import { footerImageUrl, IMAGE_RESOLUTIONS } from './constants';
import './style.scss';

const Footer = ({ footerTitle, onSubmit, briefParams }) => (
    <footer className="buyer-ideas-footer">
        <div className="buyer-ideas-footer-wrapper max-width-container inner">
            <div className="content-wrapper">
                <h2>{footerTitle}</h2>
                <p>
                    <I18n k="logo_maker_perseus.buyer_ideas.footer.made_by_humans" />
                </p>
                <form
                    className="cta-wrapper"
                    action={getBriefUrl()}
                    method="get"
                    autoComplete="off"
                    onSubmit={onSubmit}
                >
                    {briefParams &&
                        Object.keys(briefParams).map((fieldName, i) => (
                            <input key={i} type="hidden" name={fieldName} value={briefParams[fieldName]} />
                        ))}
                    <Input
                        className="cta-input-wrapper"
                        inputClassName="cta-input"
                        placeholder={translate('logo_maker_perseus.buyer_ideas.footer.enter_your_name')}
                        aria-label={translate('logo_maker_perseus.buyer_ideas.footer.enter_your_name')}
                        data-lpignore="true"
                        name="get_started_brand_name"
                    />
                    <Button
                        className="cta-btn get-started-desktop"
                        color={Button.COLORS.WHITE}
                        textColor={Button.TEXT_COLORS.BLUE}
                        size={Button.SIZES.LARGE}
                        type="submit"
                    >
                        <I18n k="logo_maker_perseus.general.make_your_logo" />
                    </Button>
                    <Button
                        className="cta-btn get-started-mobile"
                        color={Button.COLORS.WHITE}
                        textColor={Button.TEXT_COLORS.BLUE}
                        size={Button.SIZES.LARGE}
                        type="submit"
                    >
                        <I18n k="logo_maker_perseus.general.start" />
                    </Button>
                </form>
            </div>
            <div className="footer-image-wrapper">
                <CloudinaryResponsiveImage
                    image={footerImageUrl}
                    alt={translate('logo_maker_perseus.buyer_ideas.footer.image_alt')}
                    mediaQueryGrid={IMAGE_RESOLUTIONS}
                />
            </div>
        </div>
    </footer>
);

Footer.propTypes = {
    footerTitle: string,
    onSubmit: func,
    briefParams: object,
};

export default Footer;
